import React from "react";
import { ButtonWIcon } from "./Inputs";
import "../css/mobile_app_page.css";

export default function MobileAppPage() {

    function downloadAndroid() {
            window.open("https://drive.usercontent.google.com/download?id=1YKPp9VnJfNKwSqrbDn7PM4v2p3jrWFGn&export=download", "_blank");
        
    }


    return (
            <div className="mob-app-page">
                <h1>Stáhněte si naší mobilní aplikaci terminálu pro Android & IOS</h1>
                <p className="desc">Zapisujte podporu vašich klientů díky naší aplikaci pro mobilní telefon.
                    Mobilní telefon musí podporovat NFC komunikaci.
                    Heslo k terminálu je stéjné, jako do webové aplikace PeerSight. Stačí, aby váš účet měl oprávnění 2. úrovně.
                </p>
                <section className="img-section">
                    <img src='/img/mobile_app/prilozte_kartu.png' alt='Přiložte kartu k terminálu' />
                    <img src='/img/mobile_app/saved_aid.png' alt='pict 2' />
                </section>
                <div className="control-bar">
                    <div className="side">
                        <ButtonWIcon iconSrc="/img/svg/download.svg" text="Stáhnout pro Android" onClick={downloadAndroid} />
                    </div>
                    <div className="side">
                        <a href="https://apps.apple.com/cz/app/peersight/id6523287079?l=cs">
                            <img src="/img/app_store_logo.png" className="app-store-logo"></img>
                        </a>
                    </div>
                </div>
            </div>
    )
}
